import { Navigate, Outlet } from "react-router-dom";
import SecondarySidebarLayout from "components/wrappers/SecondarySidebarLayout";
import Departments from "pages/settings/Departments";
import FingerPrints from "pages/settings/FingerPrints";
import Locations from "pages/settings/Locations";
import Projects from "pages/settings/Projects";
import Users from "pages/settings/Users";
import Workflow from "pages/settings/Workflow";
import Zones from "pages/settings/Zones";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";
import ProtectedOutlet from "components/wrappers/ProtectedOutlet";
import { PermissionCodename } from "constants/permission";

interface OrganizationRoute {
  path: string;
  element: JSX.Element;
  children?: OrganizationRoute[];
  permission?: PermissionCodename;
}

export default function useOrganizationRoutes() {
  const { hasPermissionTo } = usePermissions();

  const children: OrganizationRoute[] = [
    {
      path: "",
      element: <Navigate to="departments" />,
    },
    {
      path: "departments",
      element: (
        <ProtectedOutlet >
          <Outlet />
        </ProtectedOutlet>
      ),
      children: [
        {
          path: "",
          element: <Departments />,
        },
        {
          path: "staff",
          element: <Users title="Departments" isForDepartments isAddUserHidden />,
        },
      ],
    },
    {
      path: "zones",
      element: (
        <ProtectedOutlet >
          <Zones />
        </ProtectedOutlet>
      ),
    },
    {
      path: "locations",
      element: (
        <ProtectedOutlet >
          <Locations />
        </ProtectedOutlet>
      ),
    },
    {
      path: "fingerprints",
      element: (
        <ProtectedOutlet >
          <FingerPrints />
        </ProtectedOutlet>
      ),
    },
    {
      path: "projects",
      element: (
        <ProtectedOutlet >
          <Projects />
        </ProtectedOutlet>
      ),
    },
    {
      path: "workflow",
      permission: "workflow_setup",
      element: (
        <ProtectedOutlet requiredPermission="workflow_setup">
          <Workflow />
        </ProtectedOutlet>
      ),
    },
  ];

  const filteredList = filterByPermissions(children, hasPermissionTo);

  return {
    path: "settings/organization",
    element: (
      <SecondarySidebarLayout list={filteredList} title="Organization">
        <Outlet />
      </SecondarySidebarLayout>
    ),
    children,
  };
}
